export var IGoogleVersion;
(function (IGoogleVersion) {
    IGoogleVersion["WEEKLY"] = "weekly";
    IGoogleVersion["QUARTERLY"] = "quarterly";
})(IGoogleVersion || (IGoogleVersion = {}));
